var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 25.9998V28.2998H2V25.9998C2.02043 22.8024 3.11189 19.704 5.1 17.1998C6.42995 15.4716 8.14261 14.0755 10.1033 13.1212C12.0641 12.1668 14.2194 11.6803 16.4 11.6998C18.6032 11.6919 20.7784 12.1932 22.7558 13.1646C24.7333 14.136 26.4596 15.5512 27.8 17.2998C29.7182 19.7971 30.7712 22.8509 30.8 25.9998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4001 13.5C29.4008 14.2082 29.2596 14.9093 28.9848 15.562C28.7099 16.2146 28.3071 16.8056 27.8001 17.3C26.4597 15.5515 24.7334 14.1363 22.7559 13.1649C20.7784 12.1935 18.6033 11.6922 16.4001 11.7C14.2195 11.6805 12.0642 12.1671 10.1034 13.1214C8.1427 14.0757 6.43004 15.4719 5.10008 17.2C4.16248 16.1929 3.62852 14.8757 3.60008 13.5C3.58679 12.8088 3.71147 12.1218 3.96683 11.4793C4.2222 10.8368 4.60312 10.2518 5.08732 9.75825C5.57151 9.26474 6.14926 8.87273 6.78676 8.60517C7.42426 8.33762 8.10871 8.19989 8.80008 8.20002C9.6792 8.21823 10.5393 8.45908 11.3001 8.90003C11.3767 7.57355 11.9582 6.32669 12.9253 5.41547C13.8923 4.50426 15.1714 3.99779 16.5001 4.00001C17.8218 4.02119 19.0879 4.53549 20.0499 5.44202C21.0119 6.34856 21.6005 7.58192 21.7001 8.90003C22.4608 8.45908 23.321 8.21823 24.2001 8.20002C24.8915 8.19989 25.5759 8.33762 26.2134 8.60517C26.8509 8.87273 27.4287 9.26474 27.9128 9.75825C28.397 10.2518 28.778 10.8368 29.0333 11.4793C29.2887 12.1218 29.4134 12.8088 29.4001 13.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8999 19.6999L11.1999 18.3999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2998 21.8999L17.5998 23.2999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.0999L21.7 18.3999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaco);
export default __webpack_public_path__ + "static/media/taco.b959b28f425a5713085839fde4cd466b.svg";
export { ForwardRef as ReactComponent };